import React, { useContext, useState, useEffect } from 'react';

import RelatoriosCarvao from './relatorios-pdf-carvao.jsx';
import { Panel, PanelHeader, PanelBody, PanelStat } from '../../components/panel/panel.jsx';
import RecordInfos from '../../components/panel/record-infos.jsx';
import ActionsDropdown from '../../components/panel/actions-dropdown.jsx';
import PanelKeyboardNav from '../../components/panel/panel-keyboard-nav.jsx';
import CoalSpecifications from '../../components/panel/coal-specifications.jsx';
import CoalImageGallery from '../../components/panel/coal-image-gallery.jsx';
import PageHeaderFixed from '../../components/page-header/page-header-fixed.jsx';
import useCoalActions from '../../hooks/useCoalActions.js';
import useSearchReport from '../../hooks/useSearchReport.js';
import { AppSettings } from '../../config/app-settings.js';
import { useTranslation } from 'react-i18next';
import { useLocation, useHistory } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import coalService from '../../services/CoalService/coal-service.js';
import fieldService from '../../services/CoalService/field-service.js';
import ImageViewerModal from '../../components/panel/image-viewer-modal.jsx';

export default function Resultados(){
    const location = useLocation();
    const history = useHistory();
    const { user, ...settings } = useContext(AppSettings);
    const { t, i18n } = useTranslation();

    const [ coalList, setCoalList ] = useState(null);
    const [ filteredList, setFilteredList ] = useState(null);
	const [ currentPage, setCurrentPage ] = useState(1);
    const [ fieldList, setFieldList ] = useState(null);
	const [ lastPage, setLastPage ] = useState(1);
    const [ length, setLength ] = useState(0);
    const [ selectedCoal, setSelectedCoal ] = useState(null);
    const [ selectedCoalList, setSelectedCoalList ] = useState([]);
    const [ currentPageId, setCurrentPageId ] = useState(null);
    const [ search, setSearch ] = useState(null);
    const [ value, setValue ] = useState(1);
    const [ imageModal, setImageModal ] = useState({ images: [], index: -1 });
    const [ printSource, setPrintSource ] = useState(null); // 'coal' | 'search'

    const ACTION_BUTTON_MIN_WIDTH = 190;
    const PAGE_SIZE = 20;
    const sliceForPage = (list, page) => list.slice((page-1)*PAGE_SIZE, page*PAGE_SIZE);

    const onStatusChange = (id, newStatus) => {
        setCoalList(prevCoalList => {
            const newCoalList = prevCoalList.map(coal =>
                coal[0].id == id ? [{...(coal[0]), status: newStatus}, coal[1]] : coal
            );
            setFilteredList(sliceForPage(newCoalList, currentPage));
            return newCoalList;
        });
    }

    const afterCoalDelete = () => {
        setCoalList(prevCoalList => {
            const newCoalList = prevCoalList.filter(coal => coal[0].id != selectedCoal.id);
            setFilteredList(sliceForPage(newCoalList, currentPage));
            return newCoalList;
        });
        setLength(prevLength => prevLength - 1);
        setSelectedCoal(null);
    }

    const { printCoalList, coalReportModal, coalDeleteModal, historyModal, historyList,
        closeHistoryModal, openReportModal, openDeleteModal,
        handleReportType: handleCoalReportType,
        coalHistory, publishCoal, unpublishCoal, editCoal, viewCoal, deleteCoal
    } = useCoalActions(selectedCoal, setSelectedCoal, fieldList, onStatusChange, afterCoalDelete);

    const { MAX_QNTD_CARVAO_REALTORIO,
        printCoalList: searchPrintCoalList, searchReportModal,
        toggleSearchReportModal, openSearchReportModal,
        handleReportType: handleSearchReportType
    } = useSearchReport(selectedCoalList, fieldList);

    useEffect(() => {
		// acontece quando o componente é montado
		let _isMounted = true;

        if(location.from){
            if(location.state.fields){
                setFieldList(location.state.fields);
            }else{
                fieldService.getAllFields().then(
                    response => {        
                        setFieldList(response.data);
                    }
                ).catch(
                    err => {
                        console.log(err);
                    }
                )
            }

            if(location.state.search) setSearch(location.state.search);

            const coals = location.state.coals;
            setCoalList(coals);
            setLength(coals.length);
            setFilteredList(sliceForPage(coals, 1));
            setLastPage(Math.max(1, Math.ceil(coals.length / PAGE_SIZE)));

            if(selectedCoal) getCoalInfo(selectedCoal.id);
        }else{  //redireciona de volta pra página de pesquisa caso tenha sido acesso direto da url e não a partir de uma pesquisa
            history.push('/pesquisa');
        }

		//acontece quando o componente é desmontado
		return () => {
			_isMounted = false;
		}
	}, [i18n.language])

    useEffect(() => {
        if(coalList){
            if(coalList.length < MAX_QNTD_CARVAO_REALTORIO){
                let coalId = [];
                coalList.map((coal, i) => {
                    coalId.push(coal[0].id);
                })
                getCoalListInfo(coalId, coalList);
            }
            else{
                setSelectedCoalList(false);
            }
        }
        
    }, [coalList])

    const getCoalListInfo = async (coalId, searchListCoals) => {
        const coalSearchInfo = await coalService.getInfoCoalSearch(coalId, coalId.length);
        coalSearchInfo.data.map((coal, id) => {
            coal.espec = getCoalEspecs(coalSearchInfo.data[id], coalSearchInfo.data[id].id, undefined, undefined, searchListCoals);
        })
        setSelectedCoalList(coalSearchInfo.data);
    }

    const getPage = (direction, changingCoal) => {
        let current = currentPage;
		let isMounted = true;

        if(direction === 0){
            if(current === 1){
                settings.handleSetAlert('info', '', t('alerta.paginação.ini'));

                return 0;
            }
            current = current - 1;
        }else if (direction === 1){
            if (current === lastPage){
				settings.handleSetAlert('info', '', t('alerta.paginação.fim'));

                return 0;
            }
            current = 1 + parseInt(current);
        }
        setValue(current);
        
		if(isMounted){
            const newList = sliceForPage(coalList, current);
			setCurrentPage(current);
            setValue(current);
			setFilteredList(newList);
            if(changingCoal == true){
                if(direction === 0){
                    getCoalInfo(newList[newList.length - 1][0].id, newList, current);
                }else{
                    getCoalInfo(newList[0][0].id, newList, current);
                }
            }
		}
    }

    const handlePageInputChange = (e) => {
        setValue(e.target.value.replace(/\+|-/ig, ''));
    }

    const handlePageSubmitChange = (e, changingCoal) =>{
        e.preventDefault();
        let isMounted = true;

        if(value > lastPage){
            settings.handleSetAlert('info', '', t('alerta.paginação.fim'));
            setCurrentPage(lastPage);
            setValue(lastPage);
        }else if(value < 1){
            settings.handleSetAlert('info', '', t('alerta.paginação.ini'));
            setCurrentPage(1);  
            setValue(currentPage);
        }else if(isMounted){
            const newList = sliceForPage(coalList, value);
			setCurrentPage(value);
			setFilteredList(newList);
            if(changingCoal == true){
                if(e !== 0){
                    getCoalInfo(newList[newList.length - 1][0].id, newList, value);
                }else{
                    getCoalInfo(newList[0][0].id, newList, value);
                }
            }
		}
    }

    const handleCoalDelete = () => {
        deleteCoal();
        openDeleteModal();
    }

    // relatório: individual delega pro useCoalActions, busca vai pro useSearchReport
    const handleReportType = (type) => {
        if(type === 'coal-pdf' || type === 'coal-rtf'){
            setPrintSource('coal');
            handleCoalReportType(type);
        }
        else if(type === 'search-pdf' || type === 'search-rtf'){
            setPrintSource('search');
            handleSearchReportType(type);
        }
    }

    const getCoalEspecs = (data, id, newPageList, newCurrent, searchListCoals) => {
        let especificacoes = [];
        const checked = data.checked_ids || [];
        var wrongIds = [];
        var tempList;
        var current;
        if(newPageList) { tempList = newPageList; current = newCurrent; }
        else if(searchListCoals) { tempList = searchListCoals; current = 1; }
        else { tempList = filteredList; current = currentPage; }
        tempList.map((coal, i) => {
            if(id == coal[0].id){
                setCurrentPageId(((current - 1) * PAGE_SIZE) + i + 1);
                wrongIds = Array.isArray(coal[1]) ? coal[1] : [];
            }
        })
        fieldList?.forEach(function (tab, i_1) {
            var espec = {
                tab: tab['name_' + i18n.language],
                fields: [],
                id: tab.id
            };
            tab.children?.forEach(function (label, j) {
                if (label.type == 'multi-select') {
                    var f = {
                        name: label['name_' + i18n.language],
                        values: [],
                        wrongValues: [],
                        id: label.id
                    };
                    label.children?.forEach(function (option, k) {
                        if (option.type == 'multi-select-option') {
                            var v = {
                                name: option['name_' + i18n.language],
                                id: option.id
                            };
                            if (checked.includes(option.id)) f.values.push(v);
                            if (wrongIds.includes(option.id)) f.wrongValues.push(v);
                            option.children?.forEach(function (mso, l) {
                                if (mso.type == 'mso-child') {
                                    var vc = {
                                        name: mso['name_' + i18n.language],
                                        id: mso.id
                                    };
                                    if (checked.includes(mso.id)) f.values.push(vc);
                                    if (wrongIds.includes(mso.id)) f.wrongValues.push(vc);
                                }
                            });
                        }
                    });
                    if (f.values.length > 0 || f.wrongValues.length > 0) {
                        espec.fields.push(f);
                    }
                }
            });

            if (espec.fields.length > 0) {
                especificacoes.push(espec);
            }
        });

        return especificacoes;
    }

    const getCoalInfo = async (id, newPageList, newCurrent) => {
        try {
            const response = await coalService.getInfoCoal(id);

            if(newPageList) { response.data.espec = getCoalEspecs(response.data, id, newPageList, newCurrent); }
            else { response.data.espec = getCoalEspecs(response.data, id); }
            setSelectedCoal(response.data);
            window.scrollTo(0, 0);

        } catch (err) {
            settings.handleSetAlert('danger', t('alerta.titulo.erro'), t('alerta.algoDeuErrado.mensagem'));
            console.log(err);
        } 
    }

    const nextCoal = (next) => {
        const listaTemp = filteredList;
        const index = listaTemp.findIndex(coal => coal[0].id == selectedCoal.id);
        if(index === -1) return;

        if(next == true){   //aqui vai pra frnte, no outro pra tras
            if(index != PAGE_SIZE - 1){
                if(!listaTemp[index+1]){
                    settings.handleSetAlert('info', '', t('alerta.paginação.ultimoRegistro'));
                }else{
                    getCoalInfo(listaTemp[index+1][0].id); //chama a função de infos pro prox carvao
                }
            }else{  //sendo 19 (PAGE_SIZE - 1), quer dizer que esse é o último dessa pagina e tem que ir pra próxima
                getPage(1, true);
            }
        }else{
            if(index != 0){
                getCoalInfo(listaTemp[index-1][0].id); //chama a função de infos pro prox carvao
            }else{  //sendo 0, quer dizer que esse é o primeiro dessa pagina e tem que ir pra anterior
                getPage(0, true);
            }
        }
    }
    
    const newSearch = () => {
        history.push({pathname: '/pesquisa'});
    }

    const searchAgain = () => {
        if(search)
        history.push({pathname: '/pesquisa', state: {searchData : search}, from: '/registros/todos'});
        else history.push({pathname: '/pesquisa'});
    }

    return(
        <>
            {
                (filteredList && fieldList) &&
                <>
                    <PageHeaderFixed
                        title={search != null ? t('carvão.result.todos') : t(location.state.filterTitleKey)}
                        className="screen-content"
                        rowClassName="screen-content"
                        actions={
                            search != null &&
                            <>
                                <button type="submit" onClick={openSearchReportModal}
                                    className="btn btn-primary d-block btn-lg fs-13px d-flex align-items-center justify-content-center flex-row"
                                    style={{ minWidth: ACTION_BUTTON_MIN_WIDTH }}>
                                        {t('carvão.result.botão.relatorioPesquisa')}
                                </button>
                                <button type="submit" onClick={searchAgain}
                                    className="btn btn-success d-block btn-lg fs-13px d-flex align-items-center justify-content-center flex-row"
                                    style={{ minWidth: ACTION_BUTTON_MIN_WIDTH }}>
                                        {t('carvão.result.botão.refazer')}
                                </button>
                                <button type="submit" onClick={newSearch}
                                    className="btn btn-success d-block btn-lg fs-13px d-flex align-items-center justify-content-center"
                                    style={{ minWidth: ACTION_BUTTON_MIN_WIDTH }}>
                                        {t('carvão.result.botão.pesquisa')}
                                </button>
                            </>
                        }>
                        <div className='col w-50'>
                            <Panel> 
                                <PanelHeader noButton={true} className="h-40px">
                                    <div className="d-flex flex-row fs-14px justify-content-between"> 
                                         <div className="d-flex flex-row align-items-center justify-content-center">
                                            <div className="col d-flex align-items-center">
                                                <div className="col d-flex align-items-center">
                                                    <div onClick={() => getPage(0)} style={{cursor: "pointer"}}><i className="fas fa-angle-left me-3"></i></div>
                                                        {t('paginação.page')}: 
                                                        <form className="ps-2 pe-1 mx-1" onSubmit={handlePageSubmitChange}>
                                                            <input type="text" className="form-control fs-14px fw-lighter w-50px h-35px l-20px border-0 text-end" value={value} onChange={handlePageInputChange} /> 
                                                        </form>
                                                         / {lastPage}
                                                    <div onClick={() => getPage(1)} style={{cursor: "pointer"} }><i className="fas fa-angle-right ms-3"></i></div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div className="mt-2 me-3">{t('paginação.total')}: {length}</div>                                           
                                       
                                    </div>  
                                </PanelHeader>
                                <PanelBody className="p-0">
                                    {
                                        <div className="table-responsive d-flex flex-row justify-content-between">
                                            <table className="table m-0 fs-13px">
                                                <tbody>
                                                    {   
                                                        filteredList.map((coal, index)=> 
                                                            <tr key={index} className={'d-flex justify-content-start mt-n1' + (selectedCoal? ( selectedCoal.id === coal[0].id ? ' table-primary' : '') : '')} onClick={() => getCoalInfo(coal[0].id)}>
                                                                <td width="4%" style={{paddingLeft: "10px"}} className="text-center"><i className={coal[0].status == 1 ? "fa fa-lock" : 'fa fa-globe'}></i></td>
                                                                <td width="4%" className="text-center">
                                                                    {
                                                                        coal[0].type == 1 && 'A'
                                                                    }
                                                                    {
                                                                        coal[0].type == 2 && 'R'
                                                                    }
                                                                    {
                                                                        coal[0].type == 3 && 'L'
                                                                    }
                                                                </td>
                                                                <td width="4%" className="text-center">
                                                                    <i className={coal[0].image != 0 ? "fa fa-image" : "fa fa-clipboard"}></i>
                                                                </td>
                                                                <td width="88%">
                                                                    {
                                                                        coal[0].family_name? (coal[0].family_name + (coal[0].scientific_name ? ' > ' + coal[0].scientific_name : (coal[0].genus_name? ' > ' + coal[0].genus_name : '')) + (coal[0].determination? ' > ' + coal[0].determination : ''))
                                                                                        : (coal[0].determination? coal[0].determination : t('carvão.result.nãoInformado'))
                                                                    }
                                                                </td>
                                                            </tr> 
                                                        )
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    }
                                </PanelBody>
                            </Panel>
                        </div>

                        <div className='col w-50'>
                            <Panel> 
                                <PanelHeader className='p-2 h-40px'>
                                    { selectedCoal != null &&
                                        <div className=" d-flex flex-row justify-content-between">                                            
                                            <div className='d-flex flex-row fs-14px' >                                          
                                                <div className="d-flex flex-row align-items-center justify-content-center">
                                                    <div onClick={() => nextCoal(false)} style={{cursor: "pointer"}}><i className="fas fa-angle-left me-3"></i></div>
                                                        <div>{t('carvão.result.registro')}: {currentPageId} / {length}</div>
                                                    <div onClick={() => nextCoal(true)} style={{cursor: "pointer"}}><i className="fas fa-angle-right ms-3 me-3"></i></div>
                                                </div>
                                            </div>
                                            <ActionsDropdown
                                                selectedCoal={selectedCoal}
                                                user={user}
                                                onView={viewCoal}
                                                onReport={openReportModal}
                                                onPublish={publishCoal}
                                                onUnpublish={unpublishCoal}
                                                onHistory={coalHistory}
                                                onEdit={editCoal}
                                                onDelete={openDeleteModal}
                                            />
                                        </div>
                                    }
                                </PanelHeader>
                                <PanelBody className="fs-13px">
                                    {
                                        selectedCoal === null &&
                                        (<p>
                                            {t('carvão.result.informações.selecioneParaSaberMais')}
                                        </p>)
                                    }
                                    {
                                        selectedCoal &&
                                        (<div>
                                            <PanelStat.Consumer>
                                                {({ expand, toggleExpand }) => (
                                                    <>
                                                        <RecordInfos selectedCoal={selectedCoal} fullScreen={expand} />
                                                        <PanelKeyboardNav expand={expand && imageModal.index < 0} toggleExpand={toggleExpand} onPrev={() => nextCoal(false)} onNext={() => nextCoal(true)} />
                                                    </>
                                                )}
                                            </PanelStat.Consumer>
                                                <CoalSpecifications selectedCoal={selectedCoal} fieldList={fieldList} showWrongValues={true} />
                                                <CoalImageGallery images={selectedCoal.images} onImageClick={(i) => setImageModal({ images: selectedCoal.images.map(img => img.photo), index: i })} />
                                        </div>)
                                    }
                                </PanelBody>
                            </Panel>
                        </div>

                        <Modal isOpen={searchReportModal} toggle={toggleSearchReportModal} className="screen-content">
                            <ModalHeader 
                                toggle={toggleSearchReportModal} 
                                close={
                                    <button className="btn-close" onClick={toggleSearchReportModal}></button>
                                }>
                                    <i className="fa fa-circle-exclamation"></i> {t('carvão.result.botão.relatorioPesquisa')}
                            </ModalHeader>    

                            <ModalBody>
                                <div className="alert mb-0 fs-5">
                                    <p>{t('relatório.modal.texto')}</p>
                                </div>
                            </ModalBody>

                            <ModalFooter>
                                <button className="btn btn-secondary fs-11px" onClick={toggleSearchReportModal}>
                                    {t('botão.cancelar')}</button>
                                <button className="btn btn-primary fs-11px" type="submit" onClick={ () => (handleReportType("search-pdf"))} disabled={selectedCoalList.length == 0}>
                                    {t('relatório.botão.pdf-pesquisa')}</button>
                                <button className="btn btn-success fs-11px" type="submit" onClick={ () => (handleReportType("search-rtf"))} disabled={selectedCoalList.length == 0}>
                                    {t('relatório.botão.rtf-pesquisa')}</button>
                            </ModalFooter>
                        </Modal>

                        <Modal isOpen={coalReportModal} toggle={openReportModal} className="screen-content">
                            <ModalHeader 
                                toggle={openReportModal} 
                                close={
                                    <button className="btn-close" onClick={openReportModal}></button>
                                }>
                                    <i className="fa fa-circle-exclamation"></i> {t('carvão.result.botão.relatorio')}
                            </ModalHeader>    

                            <ModalBody>
                                <div className="alert mb-0 fs-5">
                                    <p>{t('relatório.modal.texto')}</p>
                                </div>
                            </ModalBody>

                            <ModalFooter>
                                <button className="btn btn-secondary fs-11px" onClick={openReportModal}>
                                    {t('botão.cancelar')}</button>
                                <button className="btn btn-primary fs-11px" type="submit" onClick={ () => (handleReportType("coal-pdf"))}>
                                    {t('relatório.botão.pdf')}</button>
                                <button className="btn btn-success fs-11px" type="submit" onClick={ () => (handleReportType("coal-rtf"))}>
                                    {t('relatório.botão.rtf')}</button>
                            </ModalFooter>
                        </Modal>

                        <Modal isOpen={coalDeleteModal} toggle={openDeleteModal}>
                            <ModalHeader toggle={openDeleteModal} close={<button className="btn-close" onClick={openDeleteModal}></button>}><i className="fa fa-circle-exclamation"></i> {t('modal.atenção')}</ModalHeader>
                                <ModalBody>
                                    <div className="alert mb-0 fs-5">
                                        <p>{t('carvão.result.modal.remover.texto1')}</p>
                                        <p>{t('carvão.result.modal.remover.texto2')}</p>
                                    </div>
                                </ModalBody>
                                <ModalFooter>
                                    <button className="btn btn-secondary" onClick={openDeleteModal}>{t('botão.cancelar')}</button>
                                    <button className="btn btn-danger" onClick={() => handleCoalDelete()} type="submit" >
                                    {t('gerencia.botão.removerComCerteza')}</button>
                                </ModalFooter>
					    </Modal>
                        
                        <ImageViewerModal images={imageModal.images} startIndex={imageModal.index} isOpen={imageModal.index >= 0} onClose={() => setImageModal(m => ({ ...m, index: -1 }))} />

                        <Modal isOpen={historyModal} toggle={closeHistoryModal}>
                            <ModalHeader
                                toggle={closeHistoryModal}
                                close={
                                    <button className="btn-close" onClick={closeHistoryModal}></button>
                                }>
                            </ModalHeader>
                            <ModalBody>
                                <div className="row">
                                    <div className="col">
                                        {
                                            historyList?.map(value => {
                                                let typeString;
                                                switch (value.tipo) {
                                                    case 1:
                                                        typeString = t('carvão.result.historico.criar');
                                                        break;
                                                    case 2:
                                                        typeString = t('carvão.result.historico.editar');
                                                        break;
                                                    case 3:
                                                        typeString = t('carvão.result.historico.publicar');
                                                        break;
                                                    case 4:
                                                        typeString = t('carvão.result.historico.privar');
                                                        break;
                                                    case 5:
                                                        typeString = t('carvão.result.historico.inativado');
                                                        break;
                                                    case 6:
                                                        typeString = t('carvão.result.historico.relatorio');
                                                        break;
                                                    default:
                                                        break;
                                                }
                                                return (
                                                    <div className="row ">
                                                        <div className="col w-50">
                                                            <p>{t('carvão.result.historico.texto1')} <b>{typeString}</b> {t('carvão.result.historico.em')} <b>{value.data}</b> {t('carvão.result.historico.por')} <b>{value.name}</b>.</p>
                                                        </div>
                                                    </div>
                                                );
                                            })
                                        }
                                    </div>
                                </div>
                            </ModalBody>
                        </Modal>
                    </PageHeaderFixed>

                    { 
                        coalList &&
                            <RelatoriosCarvao printCoalList={printSource === 'search' ? searchPrintCoalList : printCoalList} fieldList={fieldList} />
                    }
                    
                </>
            }
        </>
    )
}